// Competition logos
import serieALogo from '../assets/images/SerieALogo.png';
import championsLeagueLogo from '../assets/images/UEFA_Champions_League_logo_2.svg.png';
import europaLeagueLogo from '../assets/images/Logo_UEFA_Europa_League_-_2021.svg.png';
import conferenceLeagueLogo from '../assets/images/UECL_logo.png';
import superCupLogo from '../assets/images/UEFA_Super_Cup_logo.png';
import coppaItaliaLogo from '../assets/images/Coppa_Italia_logo.png';
import { getTeamLogoPath } from './teamLogoLoader';
import { getCustomTeamLogoUrl } from './customTeamLogos';

export const competitionLogos = {
  'Serie A': serieALogo,
  'Champions League': championsLeagueLogo,
  'UEFA Europa League': europaLeagueLogo,
  'UEFA Europa Conference League': conferenceLeagueLogo,
  'UEFA Super Cup': superCupLogo,
  'Coppa Italia': coppaItaliaLogo,
  'Match amical': serieALogo,
};

export const getCompetitionLogo = (competitionName) => {
  return competitionLogos[competitionName] || null;
};

// Mapping of teams to their logo files (from Archive)
// These are now resolved dynamically using getTeamLogoPath
export const teamLogos = {
  // Serie A teams
  'AC Milan': 'Milan.svg',
  'Milan': 'Milan.svg',
  'Atalanta': 'Atalanta_Bergame_2024.svg',
  'Bologna': 'Bologna.png',
  'Cagliari': 'Cagliari_Calcio_1920_logo.svg',
  'Como 1907': 'Como_-_logo_(Italy,_2019-).svg',
  'Como': 'Como_-_logo_(Italy,_2019-).svg',
  'Cremonese': 'Cremonese_2018.svg',
  'Fiorentina': 'Fiorentina_2022.svg',
  'Genoa': 'Genoa_CFC_-_2022.svg',
  'Hellas Verona': 'Hellas_Verona_FC_logo_(2020).svg',
  'Verona': 'Hellas_Verona_FC_logo_(2020).svg',
  'Inter Milan': 'INTER.png',
  'Inter': 'INTER.png',
  'Juventus': 'Juventus_(white_on_black).svg',
  'Juventus FC': 'Juventus_(white_on_black).svg',
  'Juve': 'Juventus_(white_on_black).svg',
  'Lazio': 'Lazio.svg',
  'Lecce': 'Lecce_2023.svg',
  'Napoli': 'Napoli_2024.svg',
  'Parma': 'Parma_Calcio_1913.svg',
  'Pisa': 'Pisa_SC_2024.svg',
  'AC Pisa 1909': 'Pisa_SC_2024.svg',
  'Roma': 'Roma_Logo_2017.svg',
  'Sassuolo': 'Sassuolo_2024.svg',
  'US Sassuolo': 'Sassuolo_2024.svg',
  'Torino': 'Torino_FC_2024.svg',
  'Udinese': 'Logo_Udinese_Calcio_2010.svg',
  
  // Other Italian teams
  'Empoli': 'Empoli_FC_2021.svg',
  'Frosinone': 'Frosinone_Calcio_2011.svg',
  'Monza': 'Monza_2019.svg',
  'Modena': 'Modena_FC_-_2022.svg',
  'Palermo': 'Palermo_FC_-_2024.svg',
  'Reggiana': 'Reggiana_1919_(2024).svg',
  'Sampdoria': 'Sampdoria_1997.svg',
  'Spezia': 'Spezia_Calcio_2025.svg',
  
  // European teams - La Liga
  'Real Madrid': 'Real_Madrid.svg',
  'Barcelona': 'Barcelone.svg',
  'Barcelone': 'Barcelone.svg',
  'Atletico Madrid': 'Atletico Madrid_2024.svg',
  'Sevilla': 'Séville_FC.svg',
  'Villarreal': 'Logo_Villarreal_CF_2009.svg',
  'Real Betis': 'Real_betis_logo.svg',
  'Athletic Bilbao': 'Athletic_Club_1995.svg',
  
  // Bundesliga
  'Bayern Munich': 'Bayern_München_logo_(2024).svg',
  'Bayern München': 'Bayern_München_logo_(2024).svg',
  'Borussia Dortmund': 'BORUSSIA DORTMUND.png',
  'Stuttgart': 'Stuttgart_1893_Logo.svg',
  'Leverkusen': 'Bayer_04_Leverkusen_(logo).svg',
  'Eintracht Frankfurt': 'Eintracht_Francfort.svg',
  'Freiburg': 'SC_Freiburg_(logo).svg',
  
  // Premier League
  'Liverpool': 'Liverpool_FC_2012.svg',
  'Manchester City': 'Manchester_City_2016.svg',
  'Manchester United': 'Manchester_United_FC.svg',
  'Arsenal': 'Arsenal_FC_2002.svg',
  'Tottenham': 'Tottenham_Hotspur_Football_Club_2024.svg',
  'Newcastle': 'Newcastle_United_FC.svg',
  'Aston Villa': 'Aston_Villa_FC_2024.svg',
  'Nottingham Forest': 'Nottingham_Forest_FC.svg',
  
  // Ligue 1
  'PSG': 'Paris_Saint-Germain_2024.svg',
  'Paris Saint-Germain': 'Paris_Saint-Germain_2024.svg',
  'Marseille': 'Olympique_de_Marseille.svg',
  'Monaco': 'Monaco_FC_2021.svg',
  'Lille': 'LOSC_Lille_2018.svg',
  'Rennes': 'Stade_Rennais_FC.svg',
  'Nantes': 'Nantes_(avec_fond)_-_2019.svg',
  
  // Primeira Liga
  'Porto': 'Porto.svg',
  'Benfica': 'Benfica_(3_Stars).svg',
  'Braga': 'Braga_2024.png',
  'SC Braga': 'Braga_2024.png',
  
  // Eredivisie
  'Ajax': 'Ajax_Amsterdam_1928-1991—2025_Logo.svg',
  'Feyenoord': 'Feyenoord_Rotterdam_2024.svg',
  'PSV': 'PSV.svg',
  
  // Turkish Super Lig
  'Fenerbahce': 'Fenerbahçe_SK_(5_Stars).svg',
  
  // Greek Super League
  'Olympiakos': 'Olympiakos_2024.svg',
  'Panathinaikos': 'Panathinaikos_F.C._logo.svg',
  
  // Swiss Super League
  'Basel': 'Basel_2023.svg',
  'Young Boys': 'BSC_Young_Boys.svg',
  
  // Belgian Pro League
  'Club Brugge': 'Club_Brugge_KV_2024.svg',
  'Genk': 'KRC_Genk_2021.svg',
  'Standard Liege': 'Standard_de_Liège_2019.svg',
  'Union Saint-Gilloise': 'Royale_Union_Saint-Gilloise_2025.svg',
  
  // Other European teams
  'Copenhagen': 'Copenhagen_logo.svg',
  'Midtjylland': 'Midtjylland_2025.svg',
  'Slavia Prague': 'Slavia_2024.svg',
  'Viktoria Plzen': 'Viktoria PlzenCVP_official_logo.svg',
  'Ferencvaros': 'Ferencváros_TC.svg',
  'Qarabag': 'Qarabağ_FK_2024.svg',
  'Bodø/Glimt': 'Bodø_Glimt.svg'
};

function findStaticLogoFileName(teamName) {
  if (!teamName) return null;

  let logoFileName = teamLogos[teamName];

  if (!logoFileName) {
    const teamKey = Object.keys(teamLogos).find(
      (key) => key.toLowerCase() === teamName.toLowerCase(),
    );
    if (teamKey) {
      logoFileName = teamLogos[teamKey];
    } else {
      const partialMatch = Object.keys(teamLogos).find(
        (key) =>
          teamName.toLowerCase().includes(key.toLowerCase()) ||
          key.toLowerCase().includes(teamName.toLowerCase()),
      );
      if (partialMatch) {
        logoFileName = teamLogos[partialMatch];
      }
    }
  }

  return logoFileName || null;
}

/**
 * Indique si une équipe a un logo dédié (bundle ou upload admin), hors logo par défaut Juventus.
 */
export const hasTeamLogo = (teamName) => {
  if (!teamName) return false;
  if (getCustomTeamLogoUrl(teamName)) return true;
  return Boolean(findStaticLogoFileName(teamName));
};

/**
 * Get the logo path for a team name
 * @param {string} teamName - The name of the team
 * @returns {string} - The path to the team logo, or a default logo if not found
 */
export const getTeamLogo = (teamName) => {
  if (!teamName) {
    return getTeamLogoPath('Juventus_(white_on_black).svg');
  }

  const customLogo = getCustomTeamLogoUrl(teamName);
  if (customLogo) return customLogo;

  const logoFileName = findStaticLogoFileName(teamName) || 'Juventus_(white_on_black).svg';
  return getTeamLogoPath(logoFileName);
};

/**
 * Extract team names from a match title (e.g., "Juventus vs Napoli" -> ["Juventus", "Napoli"])
 * @param {string} matchTitle - The match title
 * @returns {Array} - Array of team names [homeTeam, awayTeam]
 */
export const extractTeamsFromMatch = (matchTitle) => {
  if (!matchTitle) return [null, null];
  
  // Common separators: " vs ", " - ", " v ", " VS "
  const separators = [' vs ', ' VS ', ' - ', ' v ', ' V '];
  
  for (const separator of separators) {
    if (matchTitle.includes(separator)) {
      const [homeTeam, awayTeam] = matchTitle.split(separator);
      return [homeTeam.trim(), awayTeam.trim()];
    }
  }
  
  return [null, null];
};

/**
 * Get logos for both teams in a match
 * @param {string} matchTitle - The match title
 * @returns {Object} - Object with homeLogo and awayLogo
 */
export const getMatchLogos = (matchTitle) => {
  const [homeTeam, awayTeam] = extractTeamsFromMatch(matchTitle);
  
  return {
    homeTeam,
    awayTeam,
    homeLogo: getTeamLogo(homeTeam),
    awayLogo: getTeamLogo(awayTeam)
  };
};





